import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';

export const useDeleteCustomerLogo = (customerId: number) => {
  const queryClient = useQueryClient();

  const deleteCustomerLogo = async () => {
    await Axios.delete(`${DELETE_URL(customerId.toString()).deleteLogo}`);
  };

  return useMutation<void, AxiosError<BaseError>>(deleteCustomerLogo, {
    onSuccess: () => {
      queryClient.invalidateQueries(['customerLogo', 'customer', customerId]);
    },
    useErrorBoundary: false
  });
};
